module.exports = __webpack_public_path__ + "img/CloudMain.92c4928.png";